import {
  ENVIARMAIL_ERROR,
  ENVIARMAIL_SUCCESS,
  ENVIARMAIL_LOADING,
  ENVIARMAIL_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import enviarMailInitialState from "../initialStates/enviarMailInitialState";

const enviarMail = (state, { payload, type }) => {
  switch (type) {
    case ENVIARMAIL_LOADING:
      return {
        ...state,
        enviarMail: {
          ...state.enviarMail,
          error: false,
          loading: true
        },
      };
    case ENVIARMAIL_SUCCESS:
      return {
        ...state,
        enviarMail: {
          ...state.enviarMail,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ENVIARMAIL_ERROR:
      return {
        ...state,
        enviarMail: {
          ...state.enviarMail,
          error: payload,
          loading: false,
        },
      };
    case ENVIARMAIL_RESET:
      return enviarMailInitialState;
    case RESET_PORTAL_CONTEXT:
      return enviarMailInitialState;

    default:
      return state;
  }
};

export default enviarMail;
